/**
* @Author: zachalam
* @Date:   2017-03-09T09:07:59-08:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   zachalam
* @Last modified time: 2017-03-09T09:07:59-08:00
*/

import * as sdk from '../sdk';
import { storeErrors, setLoading } from './commonActions';
import { browserHistory } from 'react-router';
import { toast } from 'react-toastify';

export const storeBillingPackages = (payload) => {
  return {
    type: 'STORE_PACKAGES',
    payload
  }
}

export const storeBillingPayments = (payload) => {
  return {
    type: 'STORE_PAYMENTS',
    payload
  }
}

export const storeSubscription = (payload) => {
  return {
    type: 'STORE_SUBSCRIPTION',
    payload
  }
}


export const getBillingPackages = () => {
  return (dispatch, getState) => {
    return sdk.getBillingPackages(getState().auth.jwToken)
              .then((response) => {
                dispatch(storeBillingPackages(response.data.data));
              })
              .catch((error) => {
                // error.
              })
  }
}


export const postBillingPayment = (formData) => {
  return (dispatch, getState) => {
    return sdk.postBillingPayment(getState().auth.jwToken, formData)
              .then((response) => {
                // check if payment is pending...
                let resp = response.data.data;
                if(resp.status === "pending") {
                  // if the response is pending and there is a url
                  // do a redirect, otherwise let the user know
                  // the transaction is pending..
                  if(resp.hasOwnProperty('url')) { window.location = resp.url; }
                  else {
                    browserHistory.push("/billing/pending")
                  }
                  
                } else {
                  // payment is great - hide Loader
                  dispatch(setLoading());
                  // redirect to billing/success
                  browserHistory.push("/billing/success");
                }
              })
              .catch((error) => {
                dispatch(setLoading());
                dispatch(storeErrors({...error.response.data, invalid: 'We were unable to process your payment. Please double check your card number and try again.'}));
              })
  }
}


export const getRecentSubscription = () => {
    return(dispatch, getState) => {
      return sdk.getRecentSubscription(getState().auth.jwToken)
                .then((response) => {
                  dispatch(storeSubscription(response.data.data));
                })
    }
}

export const getBillingPayments = () => {
  return (dispatch, getState) => {
    return sdk.getBillingPayments(getState().auth.jwToken)
              .then((response) => {
                dispatch(storeBillingPayments(response.data.data));
              })
  }
}

export const deleteActiveSubscription = () => {
  return (dispatch, getState) => {
    return sdk.deleteActiveSubscription(getState().auth.jwToken)
              .then((response) => {
                toast('Subscription successfully canceled!', {type: toast.TYPE.INFO});
              })
              .catch((error) => {
                toast('Unable to cancel subscription.', {type: toast.TYPE.INFO});
              })
  }
}



// WEBPACK FOOTER //
// ./src/actions/billingActions.js